<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex xs12>
        <list :edit="edit" @form="dialog = true" @clear="$refs.form.clear()" />
        <form-manager
          ref="form"
          :dialog="dialog"
          :stadium-id="stadiumId"
          :edit="edit"
          @close="dialog = false"
        />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import FormManager from './FormManager'
import List from './List'
export default {
  name: 'Rbpi',
  components: {
    List,
    FormManager,
  },
  props: {
    stadiumId: {
      type: String,
      default: '',
      required: false,
    },
    stadiumView: {
      type: Boolean,
      default: false,
      required: false,
    },
    edit: {
      type: Boolean,
      default: true,
      required: false,
    },
  },
  data() {
    return {
      dialog: false,
    }
  },
  mounted() {
    this.$store.dispatch('rbpi/resetState')
    this.initData()
  },
  computed: {
    ...mapState({
      statusOfButton: (state) => state.events.status,
    }),
  },
  methods: {
    ...mapActions({
      fetchRbpiList: 'rbpi/fetchList',
      fetchStadiums: 'stadiums/fetchSelectList',
      setStatus: 'events/setStatus',
    }),
    async initData() {
      // this.resetPagitations()

      if (!this.stadiumView) {
        this.fetchStadiums()
        await this.fetchRbpiList()
      }
    },
  },
  watch: {
    statusOfButton: function (val) {
      if (val) this.initData().finally(() => this.setStatus(false))
    },
    stadiumId(val) {
      if (val) {
        this.fetchRbpiList({ stadiumId: val })
      }
    },
  },
}
</script>
